import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useStyles } from "../../common/appStyles";
import { ThemeProvider, createTheme } from '@mui/material';

/**
 * @param props - open and redirect to login
 * @returns - a Dialog which tells users to verify their email and set a password through auth0 in their email.
 * @remarks This dialog is just for telling users to go to their emails to verify and set a password in order to log in.
 * when you press the ok button you are redirected to log in.
 */
export function VerifyEmail(props) {
    const { handleSubmit, showDialog } = props;
    const classes = useStyles();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#10AD61'
            },
            secondary: {
                main: '#10AD61'
            },
            background: {
                default: '#ffffff'
            },
        },
        typography: {
            h6: {
                color: '#484A57'
            },
            body1: {
                color: 'black'
            }
        },
    });

    const handleConfirm = () => {
        handleSubmit();
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Dialog
                    open={showDialog}
                    fullWidth
                    maxWidth={'xs'}
                >
                    <Grid container alignItems={"center"} justifyContent={'center'}>
                        <Grid item>
                            <Grid
                                container
                                className={classes.subWrapper3}
                                direction={"column"}
                                justifyContent={'center'}
                                alignItems={"center"}
                                rowSpacing={2}
                            >
                                <Grid item xl={12}>
                                    <Grid container direction={'column'} className={classes.gridPadding} >
                                        <Grid item>
                                            <Typography variant='body1' align='center'>
                                                Please Check your email to verify your account, and set a password to log in.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xl={12}>
                                    <Grid container direction={"row"} justifyContent={'center'} alignItems={'center'}>
                                        <Grid item xs={12}>
                                            <Button onClick={handleConfirm} variant='contained' fullWidth>
                                                ok
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog >
            </ThemeProvider>
        </div >
    );
}